export default __webpack_public_path__ + "static/media/alex_bergsman.df927ed0.gif";